import { styled } from 'styled-components';

import { transition } from '#/theme/theme';

export const OverlayDropContent = styled.div`
  transition: all ${transition};
`;
